﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VXSControlViewTabController = void 0;
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const gs = require("@ivanlog/gs");
const AppVX_1 = require("../../../AppVX");
const VXSManagerV2Contract_1 = require("../../../contracts/VXSManagerV2Contract");
const VXProxyUserV1Contract_1 = require("../../../contracts/VXProxyUserV1Contract");
const BiMath_1 = require("../../../BiMath");
const VXProxyUserV2Contract_1 = require("../../../contracts/VXProxyUserV2Contract");
class VXSControlViewTabController {
    constructor(view) {
        this._view = view;
        this._app = AppVX_1.AppVX.Inst;
        const ctrl = this._view.ctrls;
        this._tabs = [ctrl.tabVXSConfig, ctrl.tabVXSExecutor];
        this._tabsBtns = [ctrl.btnTabVXSConfig, ctrl.btnTabVXSBot];
        this._tabsActivateFunc = [() => { this.configLoadAsync(); }, () => { this.botLoadAsync(); }];
        ctrl.btnTabVXSConfig.onclick = () => this.activeTab(ctrl.tabVXSConfig);
        ctrl.btnTabVXSBot.onclick = () => this.activeTab(ctrl.tabVXSExecutor);
        for (const tab of this._tabs) {
            for (const help of tab.q(".help").all) {
                const message = help.q("span").first;
                if (message)
                    help.onclick = () => new modalCom.DialogOk(message.text).show();
            }
        }
        this._app.chain.onChangeAccount.addHandler(() => __awaiter(this, void 0, void 0, function* () { this.activeTab(ctrl.tabVXSConfig); }));
        //********Config*********/
        const _selected = "selected";
        ctrl.btnVXSConfig_isBurn.onclick = () => {
            ctrl.btnVXSConfig_isBurn.flipClass("selected");
            if (ctrl.btnVXSConfig_isBurn.hasClass("selected"))
                ctrl.tabVXSConfig.q(".config-bns-address").hide();
            else
                ctrl.tabVXSConfig.q(".config-bns-address").show();
        };
        ctrl.iVXSConfig_BnSIndex.el.oninput = () => {
            let value = parseFloat(ctrl.iVXSConfig_BnSIndex.el.value);
            if (value > 1)
                value = 0;
            if (value)
                ctrl.tabVXSConfig.q(".config-bns").show();
            else
                ctrl.tabVXSConfig.q(".config-bns").hide();
        };
        ctrl.iVXSConfig_SendPLSIndex.el.oninput = () => {
            let value = parseFloat(ctrl.iVXSConfig_SendPLSIndex.el.value);
            if (value > 1)
                value = 0;
            if (value)
                ctrl.tabVXSConfig.q(".config-reward").show();
            else
                ctrl.tabVXSConfig.q(".config-reward").hide();
        };
        ctrl.btnVXSConfig_RouterPulseXV1.onclick = () => {
            ctrl.btnVXSConfig_RouterPulseXV2.removeClass(_selected);
            ctrl.btnVXSConfig_RouterPulseXV1.addClass(_selected);
        };
        ctrl.btnVXSConfig_RouterPulseXV2.onclick = () => {
            ctrl.btnVXSConfig_RouterPulseXV1.removeClass(_selected);
            ctrl.btnVXSConfig_RouterPulseXV2.addClass(_selected);
        };
        ctrl.btnVXSConfigSubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const data = yield ctrl.tabVXSConfig.getFormData(true);
            const invalidFunc = (input = null) => {
                new modalCom.DialogOk("One or more inlut field parameters are wrong, click ? for more details.").show();
                if (input)
                    input.addClass("is-invalid");
            };
            const isValidAddress = (address) => { return AppVX_1.AppVX.Inst.chain.web3.utils.isAddress(address); };
            const scope = VXSManagerV2Contract_1.VXStrategyScope.NewEmpty();
            //Валидация на sendPLS
            if (!data.uPLSInStake) {
                invalidFunc();
                return;
            }
            else
                scope.uPLSInStake = data.uPLSInStake;
            if (data.sendPLSIndex !== "") {
                const index = parseFloat(data.sendPLSIndex);
                if (index > 1 || index < 0) {
                    invalidFunc();
                    return;
                }
                scope.sendPLSIndex = data.sendPLSIndex;
                if (index == 0)
                    scope.sendPLSReceiver = VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress;
                else if (!isValidAddress(data.sendPLSReceiver)) {
                    invalidFunc(ctrl.iVXSConfig_SendPLSReceiver);
                    return;
                }
                else
                    scope.sendPLSReceiver = data.sendPLSReceiver;
            }
            //Валидация на bns
            if (data.bnsIndex !== "") {
                const index = parseFloat(data.bnsIndex);
                if (index > 1 || index < 0) {
                    invalidFunc();
                    return;
                }
                scope.bnsIndex = data.bnsIndex;
                if (index == 0) {
                    scope.swapRouterV2 = VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress;
                    scope.swapPath = [];
                    scope.swapMinPLSAmount = "0";
                    scope.swapMaxPLSAmount = "0";
                    scope.sendAddress = VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress;
                    scope.isBurnWithERC20Burn = false;
                }
                else {
                    if (ctrl.btnVXSConfig_RouterPulseXV1.hasClass(_selected))
                        data.swapRouterV2 = AppVX_1.AppVX.ADDRESS_PulseXRouterV1;
                    else if (ctrl.btnVXSConfig_RouterPulseXV2.hasClass(_selected))
                        data.swapRouterV2 = AppVX_1.AppVX.ADDRESS_PulseXRouterV2;
                    if (!isValidAddress(data.swapRouterV2)) {
                        invalidFunc();
                        return;
                    }
                    else
                        scope.swapRouterV2 = data.swapRouterV2;
                    if (data.swapPath == "") {
                        invalidFunc(ctrl.iVXSSConfig_SwapPath);
                        return;
                    }
                    let pathRaw = gs.text.replaceAll(data.swapPath, ",", " ").split(" ");
                    let path = ["0xA1077a294dDE1B09bB078844df40758a5D0f9a27"];
                    for (let step of pathRaw) {
                        step = step.trim();
                        if (!step)
                            continue;
                        if (!isValidAddress(step)) {
                            invalidFunc(ctrl.iVXSSConfig_SwapPath);
                            return;
                        }
                        path.push(step);
                    }
                    if (new Set(path).size !== path.length) {
                        invalidFunc(ctrl.iVXSSConfig_SwapPath);
                        return;
                    }
                    if (path.length < 2) {
                        invalidFunc(ctrl.iVXSSConfig_SwapPath);
                        return;
                    }
                    scope.swapPath = path;
                    const minSwap = parseFloat(data.swapMinPLSAmount);
                    const maxSwap = parseFloat(data.swapMaxPLSAmount);
                    if (minSwap > maxSwap) {
                        invalidFunc(ctrl.iVXSConfig_SwapMinPLSAmount);
                        return;
                    }
                    if (maxSwap < 1) {
                        invalidFunc(ctrl.iVXSConfig_SwapMaxPLSAmount);
                        return;
                    }
                    scope.swapMinPLSAmount = data.swapMinPLSAmount;
                    scope.swapMaxPLSAmount = data.swapMaxPLSAmount;
                    if (ctrl.btnVXSConfig_isBurn.hasClass('selected')) {
                        scope.isBurnWithERC20Burn = true;
                        scope.sendAddress = VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress;
                    }
                    else {
                        scope.isBurnWithERC20Burn = false;
                        if (!isValidAddress(data.sendAddress)) {
                            invalidFunc(ctrl.iVXSSConfig_SendAddress);
                            return;
                        }
                        else
                            scope.sendAddress = data.sendAddress;
                    }
                }
            }
            if (parseFloat(scope.bnsIndex) + parseFloat(scope.sendPLSIndex) > 1) {
                new modalCom.DialogOk("Index sum of portion distributions equals to 1 or more.").show();
                return;
            }
            if (scope.swapRouterV2 == VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress)
                scope.swapRouterV2 = AppVX_1.AppVX.ADDRESS_PulseXRouterV2;
            const result = yield this.awaitInLockUIAsync(this._app.chain.vxsManagerV2.configureAsync(scope, false));
            if (!result)
                return;
            yield this.configLoadAsync();
        });
        ctrl.btnVXSConfigDepositUPLS.onclick = () => __awaiter(this, void 0, void 0, function* () {
            if (!this._strategyAdr)
                return;
            const uplsValue = ctrl.iVXSConfig_DepositUPLS.value;
            if (!uplsValue) {
                ctrl.iVXSConfig_DepositUPLS.addClass("is-invalid");
                return;
            }
            yield this.awaitInLockUIAsync(this._app.chain.vxERC20.transfer(this._strategyAdr, uplsValue));
            ctrl.iVXSConfig_DepositUPLS.value = "";
            yield this.configLoadAsync();
        });
        ctrl.btnVXSConfigWithdrawPLS.onclick = () => __awaiter(this, void 0, void 0, function* () {
            if (!this._strategyAdr)
                return;
            const result = yield this.awaitInLockUIAsync(this._app.chain.vxsManagerV2.withdrawPLS());
        });
        ctrl.btnVXSConfigWithdrawUPLS.onclick = () => __awaiter(this, void 0, void 0, function* () {
            if (!this._strategyAdr)
                return;
            const balance = yield this._app.chain.vxERC20.balanceOf(this._strategyAdr);
            if (!balance)
                return;
            const result = yield this.awaitInLockUIAsync(this._app.chain.vxsManagerV2.withdrawUPLS(balance));
            yield this.configLoadAsync();
        });
        //********Bot*********/
        ctrl.btnVXSBotSubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const data = yield ctrl.tabVXSExecutor.getFormData(false);
            if (!data) {
                new modalCom.DialogOk("One or more inlut field parameters are wrong, click ? for more details.").show();
                return;
            }
            const config = new VXSManagerV2Contract_1.VXStrategyBotConfig();
            config.swapMaxSlippageIndex = data.swapMaxSlippageIndex;
            config.swapFrequencySeconds = parseInt(data.swapFrequencyHours) * 3600;
            config.splitFrequencySeconds = parseInt(data.splitFrequencyHours) * 3600;
            config.splitMinProfitAmount = data.splitMinProfitAmount;
            config.maxGasAmount = data.maxGasAmount;
            const result = yield this.awaitInLockUIAsync(this._app.chain.vxsManagerV2.configureBotAsync(config));
            if (!result)
                return;
            yield this.botLoadAsync();
        });
        //********Migration*********/
        ctrl.btnVXSMigrationSubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
            while (true) {
                this._view.disable();
                let oldStrategyAdr = yield this._app.chain.vxstrategyV1.getStrategy(this._app.chain.account);
                let newStrategyAdr = yield this._app.chain.vxsManagerV2.getStrategyAdr(this._app.chain.account);
                if (!oldStrategyAdr)
                    break;
                if (oldStrategyAdr == VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress)
                    break;
                let balanceUPLS = yield this._app.chain.vxERC20.balanceOf(oldStrategyAdr);
                const oldStrategy = new VXProxyUserV1Contract_1.VXProxyUserV1Contract(oldStrategyAdr, this._app.chain.web3);
                let scope = yield oldStrategy.getScope();
                let path = yield oldStrategy.getScopeSwapPath();
                scope.swapPath = path;
                if (parseFloat(balanceUPLS) > 0) {
                    let result = yield this.awaitInLockUIAsync(oldStrategy.withdraw_uPLS(balanceUPLS));
                    if (!result)
                        break;
                }
                if (newStrategyAdr == VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress) {
                    let result = yield this.awaitInLockUIAsync(this._app.chain.vxsManagerV2.configureAsync(scope, true));
                    if (!result)
                        break;
                }
                this._view.disable();
                newStrategyAdr = yield this._app.chain.vxsManagerV2.getStrategyAdr(this._app.chain.account);
                if (!newStrategyAdr)
                    break;
                if (newStrategyAdr == VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress)
                    break;
                if (parseFloat(balanceUPLS) > 0) {
                    let result = yield this.awaitInLockUIAsync(this._app.chain.vxERC20.transfer(newStrategyAdr, balanceUPLS));
                    if (!result)
                        break;
                }
                break;
            }
            this._view.enable();
            yield this.configLoadAsync();
        });
    }
    showAllTabs() {
        this._tabs.forEach(t => t.show());
        this._tabsBtns.forEach(t => t.show());
    }
    closeTab() {
        this._tabs.forEach((t) => t.hide());
        this._tabs.forEach((b) => b.removeClass('selected'));
        this._tabsBtns.forEach((b) => b.removeClass('selected'));
    }
    activeTab(tab) {
        this.closeTab();
        const ctrl = this._view.ctrls;
        const index = this._tabs.indexOf(tab);
        this._tabs[index].addClass('selected');
        this._tabsBtns[index].addClass('selected');
        tab.show();
        this._tabsActivateFunc[index].call(this);
    }
    getActiveTab() { return this._tabs.find(b => b.hasClass('selected')); }
    configLoadAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const ctrl = this._view.ctrls;
            ctrl.blockVXSTabs.disable();
            this._strategyAdr = yield this._app.chain.vxsManagerV2.getStrategyAdr(this._app.chain.account);
            ctrl.tabVXSConfig.q(".config-base").show();
            if (this._strategyAdr == VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress) {
                this._strategyAdr = undefined;
                ctrl.tabVXSConfig.q(".config-withdraw").hide();
                ctrl.tabVXSConfig.q(".config-deposit").hide();
                ctrl.btnTabVXSBot.disable();
                ctrl.lVXSConfigStats.hide();
                let oldStrategy = yield this._app.chain.vxstrategyV1.getStrategy(this._app.chain.account);
                if (oldStrategy != VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress) {
                    ctrl.tabVXSConfig.q(".config-base").hide();
                    ctrl.tabVXSConfig.q(".config-migration").show();
                }
                ctrl.blockVXSTabs.enable();
            }
            else {
                ctrl.tabVXSConfig.q(".config-withdraw").show();
                ctrl.tabVXSConfig.q(".config-deposit").show();
                ctrl.btnTabVXSBot.enable();
                let info = yield this._app.chain.vxsManagerV2.getStrategy(this._strategyAdr);
                const scope = info.scope_;
                let path = [...info.scope_.swapPath];
                path.splice(0, 1);
                ctrl.iVXSConfig_uPLSInStake.value = scope.uPLSInStake;
                ctrl.iVXSConfig_SendPLSIndex.value = scope.sendPLSIndex;
                ctrl.iVXSConfig_SendPLSReceiver.value = scope.sendPLSReceiver;
                ctrl.iVXSConfig_BnSIndex.value = scope.bnsIndex;
                ctrl.iVXSSConfig_SwapPath.value = path.join(",");
                ctrl.iVXSConfig_SwapMinPLSAmount.value = scope.swapMinPLSAmount;
                ctrl.iVXSConfig_SwapMaxPLSAmount.value = scope.swapMaxPLSAmount;
                ctrl.iVXSSConfig_SendAddress.value = scope.sendAddress;
                ctrl.iVXSConfig_SendPLSIndex.el.dispatchEvent(new Event("input", { bubbles: true }));
                ctrl.iVXSConfig_BnSIndex.el.dispatchEvent(new Event("input", { bubbles: true }));
                const _selected = "selected";
                ctrl.btnVXSConfig_RouterPulseXV1.removeClass(_selected);
                ctrl.btnVXSConfig_RouterPulseXV2.removeClass(_selected);
                if (scope.swapRouterV2 == AppVX_1.AppVX.ADDRESS_PulseXRouterV1)
                    ctrl.btnVXSConfig_RouterPulseXV1.addClass(_selected);
                if (scope.swapRouterV2 == AppVX_1.AppVX.ADDRESS_PulseXRouterV2)
                    ctrl.btnVXSConfig_RouterPulseXV2.addClass(_selected);
                ctrl.lVXSConfigStats.show();
                if (scope.isBurnWithERC20Burn)
                    ctrl.btnVXSConfig_isBurn.addClass("selected");
                else
                    ctrl.btnVXSConfig_isBurn.removeClass("selected");
                if (ctrl.btnVXSConfig_isBurn.hasClass("selected"))
                    ctrl.tabVXSConfig.q(".config-bns-address").hide();
                else
                    ctrl.tabVXSConfig.q(".config-bns-address").show();
                let uPLSAmount = yield this._app.chain.vxERC20.balanceOf(this._strategyAdr);
                ctrl.lVXSConfigStrategyAddress.text = this._strategyAdr;
                this._shortLabel(ctrl.lVXSConfigStrategyUPLS, BiMath_1.BiMath.ToBI(uPLSAmount), 3);
                ctrl.blockVXSTabs.enable();
            }
        });
    }
    botLoadAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const ctrl = this._view.ctrls;
            ctrl.blockVXSTabs.disable();
            const strategy = new VXProxyUserV2Contract_1.VXProxyUserV2Contract(this._strategyAdr, this._app.chain.web3);
            const config = yield strategy.getBotConfig(this._app.chain.account);
            if (!config) {
                ctrl.blockVXSTabs.enable();
                return;
            }
            if (config.swapFrequencySeconds == 0) {
                ctrl.blockVXSTabs.enable();
                this.activeTab(ctrl.tabVXSConfig);
                return;
            }
            ctrl.iVXSBot_SwapMaxSlippageIndex.value = config.swapMaxSlippageIndex;
            ctrl.iVXSBot_SwapFrequencyHours.value = parseInt(config.swapFrequencySeconds / 3600 + "") + "";
            ctrl.iVXSBot_SplitFrequencyHours.value = parseInt(config.swapFrequencySeconds / 3600 + "") + "";
            ctrl.iVXSBot_SplitMinProfitAmount.value = config.splitMinProfitAmount;
            ctrl.iVXSBot_MaxGasAmount.value = config.maxGasAmount;
            ctrl.blockVXSTabs.enable();
        });
    }
    awaitInLockUIAsync(promise) {
        return __awaiter(this, void 0, void 0, function* () {
            this._view.disable();
            try {
                const result = yield promise;
                this._view.enable();
                return result;
            }
            catch (error) {
                this._view.enable();
                throw error;
            }
        });
    }
    _shortLabel(wr, value = undefined, round = 3) {
        if (!value) {
            wr.text = "-";
            wr.onclick = undefined;
            return;
        }
        wr.text = BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(value), round);
        wr.onclick = () => wr.text = BiMath_1.BiMath.ToEth(value);
    }
}
exports.VXSControlViewTabController = VXSControlViewTabController;
//# sourceMappingURL=VXSControlViewTabController.js.map